// Swiper
import Swiper, { Navigation, Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/scrollbar";
Swiper.use([Navigation, Pagination, Autoplay]);

const swiper = new Swiper(".swiper-fv", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: "auto",
  speed: 6000,
  autoplay: {
    delay: 0,
  },
});
